
import { defineComponent } from 'vue'
import global from '@/utils/global'
import dayjs from 'dayjs'
import { ElMessageBox } from 'element-plus'
import caseNotice from '@/components/dialog/case-notice.vue'
import store from '@/store/index'
import uploadVideo from '@/components/upload-video/index.vue'
import { pcaTextArr, regionData, codeToText } from '@/utils/pca-data'
import { addReportCaseApi, insurePeriodStaffRecordQueryListApi, queryOutDangerStaffList } from '@/api/long-insure-new'
import { queryOutDangerStaffDailyList } from '@/api/insure-daily-ax'

// 需要写入/读取草稿的表单字段
const DRAFT_FIELDS = ['area', 'date', 'place', 'after', 'phone', 'accidentType', 'hurtStatus', 'hospitalStatus', 'surgeryStatus', 'outDangerPhone', 'outDangerUserId', 'visitHospital', 'userId', 'insurestartdate', 'videoList', 'injuredArea', 'currentCost', 'diagnosisResult', 'accidentStatus', 'treatmentMethod', 'accidentCause', 'temporary1', 'temporary2', 'temporary3', 'temporary4', 'temporary5', 'temporary6', 'temporary7']

export default defineComponent({
  name: 'LongInsureReportAdd',
  components: {
    caseNotice,
    uploadVideo
  },
  async created() {
    this.insureType = this.$route.query.insureType
    await this.getPeopleList()
  },
  data() {
    return {
      areaList: [],
      area: [],
      Authorization: 'Bearer' + ' ' + global.token,
      uploadAction: process.env.VUE_APP_BASE_URL + '/rest/period-insur/serve-company/upload', // 上传路径
      searchType: '',
      date: '',
      place: '',
      after: '',
      phone: '',
      accidentType: '2',
      fileSize: '',
      fileUrl: '',
      isfileLengt: true,
      hurtStatus: '1',
      hospitalStatus: '1',
      surgeryStatus: '1',
      outDangerPhone: '',
      outDangerUserId: '',
      outDangerUserName: '',
      userList: [] as any,
      videoList: [] as any,
      visitHospital: '',
      userId: '',
      showNotice: true,
      insurestartdate: '',
      insureType: '',
      activeStep: 0,
      submitting: false,
      hasDraft: false,
      draftData: null as any,
      attachmentGroups: [
        { type: 1, title: '事故现场情况及周边环境', important: false, tip: '请上传jpg/png格式图片，单张不超过10MB，最多9张' },
        { type: 2, title: '伤者全身照', important: true, tip: '请上传jpg/png格式图片，单张不超过10MB，最多9张' },
        { type: 3, title: '受伤部位特写', important: true, tip: '请上传jpg/png格式图片，单张不超过10MB，最多9张' },
        { type: 4, title: '诊断证明', important: true, tip: '请上传jpg/png格式图片，单张不超过10MB，最多9张' },
        { type: 5, title: '首诊病例', important: true, tip: '请上传jpg/png格式图片，单张不超过10MB，最多9张' },
        { type: 6, title: '检查报告', important: false, tip: '请上传jpg/png格式图片，单张不超过10MB，最多9张' },
        { type: 7, title: '挂号费单据', important: false, tip: '请上传jpg/png格式图片，单张不超过10MB，最多9张' }
      ],
      //------
      injuredArea: '',
      currentCost: '',
      diagnosisResult: '',
      accidentStatus: '',
      treatmentMethod: '',
      treatmentMethodList: [
        { label: '门诊', value: '0' },
        { label: '住院', value: '1' }
      ],
      accidentStatusList: [
        { label: '工作时间及工作岗位', value: '3' },
        { label: '工作时间及非工作岗位', value: '1' },
        { label: '非工作时间及工作岗位', value: '0' },
        { label: '非工作时间及非工作岗位', value: '2' },
        { label: '上下班途中', value: '4' }
      ],
      accidentCause: '',
      accidentCauseList: [
        { checked: false, label: '扭伤', value: '0' },
        { checked: false, label: '砸伤', value: '1' },
        { checked: false, label: '压伤', value: '2' },
        { checked: false, label: '摔伤', value: '3' },
        { checked: false, label: '烫伤', value: '4' }
      ],
      temporary1: [] as any,
      temporary2: [] as any,
      temporary3: [] as any,
      temporary4: [] as any,
      temporary5: [] as any,
      temporary6: [] as any,
      temporary7: [] as any
    }
  },
  watch: {
    // 告知书是全屏遮罩，必须等它关闭后再提示草稿，否则两个弹窗会叠在一起
    showNotice(newval, oldval) {
      if (oldval === true && newval === false && this.hasDraft) {
        // activated() 每次切回页签都会把 showNotice 重置为 true，这里只提示一次
        this.hasDraft = false
        this.confirmRestoreDraft()
      }
    },
    // 监听路由变化，当从 insureType=2 切换到 insureType=8 或反向时，Vue 会复用组件实例
    // 此时需要重新初始化 insureType 和出险人列表，避免草稿缓存混乱
    '$route.query.insureType'(newType, oldType) {
      if (newType && newType !== oldType) {
        this.resetForm()
        this.insureType = newType
        this.hasDraft = false
        this.draftData = null
        this.getPeopleList()
      }
    }
  },
  activated() {
    this.$nextTick(() => {
      this.showNotice = true
    })
  },
  mounted() {
    this.areaList = regionData as any
  },
  methods: {
    // 重置表单所有字段到初始状态，用于 insureType 切换时清空缓存数据
    resetForm() {
      this.area = []
      this.date = ''
      this.place = ''
      this.after = ''
      this.phone = ''
      this.accidentType = '2'
      this.hurtStatus = '1'
      this.hospitalStatus = '1'
      this.surgeryStatus = '1'
      this.outDangerPhone = ''
      this.outDangerUserId = ''
      this.outDangerUserName = ''
      this.visitHospital = ''
      this.userId = ''
      this.insurestartdate = ''
      this.videoList = []
      this.injuredArea = ''
      this.currentCost = ''
      this.diagnosisResult = ''
      this.accidentStatus = ''
      this.treatmentMethod = ''
      this.accidentCause = ''
      this.temporary1 = []
      this.temporary2 = []
      this.temporary3 = []
      this.temporary4 = []
      this.temporary5 = []
      this.temporary6 = []
      this.temporary7 = []
      this.activeStep = 0
      this.submitting = false
    },
    // 草稿缓存 key，按 insureType 区分安心保/安心日保，避免互相污染
    draftKey(): string {
      return 'reportCaseDraft_' + this.$route.query.insureType
    },
    readDraft() {
      try {
        const raw = localStorage.getItem(this.draftKey())
        if (!raw) return
        const data = JSON.parse(raw)
        if (data && typeof data === 'object' && Object.keys(data).length > 0) {
          this.draftData = data
          this.hasDraft = true
        }
      } catch (e) {
        // 缓存损坏时直接忽略，不阻塞页面
        console.warn('读取报案草稿失败', e)
      }
    },
    saveDraft() {
      const data: any = {}
      DRAFT_FIELDS.forEach((key) => {
        data[key] = (this as any)[key]
      })
      localStorage.setItem(this.draftKey(), JSON.stringify(data))
    },
    clearDraft() {
      localStorage.removeItem(this.draftKey())
    },
    confirmRestoreDraft() {
      ElMessageBox.confirm('您有上次未完成操作，是否继续?', '提示', {
        confirmButtonText: '继续',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.restoreDraft()
        })
        .catch(() => {
          // 不继续则不做处理，缓存保留
        })
    },
    restoreDraft() {
      if (!this.draftData) return
      DRAFT_FIELDS.forEach((key) => {
        const val = this.draftData[key]
        if (val !== undefined && val !== null) {
          // 出险人 id 需要转为数字，否则 el-select 无法匹配 userList 里的 item.id
          if (key === 'outDangerUserId' && typeof val === 'string') {
            ;(this as any)[key] = Number(val) || val
          } else {
            ;(this as any)[key] = val
          }
        }
      })
      // 注意：不要走 onSelectDangerous，它会清掉刚恢复的 date
      this.activeStep = 0
    },
    handleDisableDate(time: any) {
      if (!this.insurestartdate) {
        return true
      } else {
        const today = dayjs(this.insurestartdate).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        const date = dayjs(this.insurestartdate)
        const previousDate = date.subtract(new Date(date.format('YYYY-MM-DD HH:mm:ss')).getTime() > new Date(today).getTime() ? 1 : 0, 'day').format('YYYY-MM-DD HH:mm:ss')
        let start = new Date(previousDate).getTime()
        let end = new Date().getTime()
        return !(new Date(time).getTime() >= start && new Date(time).getTime() < end)
      }
    },
    // 出险人列表
    async getPeopleList() {
      console.log(this.$route.query.insureType, 'this.$route.query.insureType')
      // 安心保
      if (this.$route.query.insureType == 2) {
        const result = await queryOutDangerStaffList({})
        console.log(result, 'result')
        this.userList = result
        this.readDraft()
      }
      // 安心日保
      if (this.$route.query.insureType == 8) {
        const result = await queryOutDangerStaffDailyList({})
        console.log(result, 'result')
        this.userList = result
        this.readDraft()
      }
    },
    getTemporary(type: number) {
      return (this as any)['temporary' + type]
    },
    imageBeforeUpload(file: any) {
      const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
      if (!isImage) {
        this.$message.error('只能上传jpg/png格式的图片')
        return false
      }
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('单张图片不可大于10M')
        return false
      }
      return true
    },
    imageSuccess(type: number, response: { code: number; msg: string; data: { fileSize: string; fileUrl: string } }, file: any, fileList: any) {
      if (response.code === 500) {
        this.$message.error(response.msg)
        return
      }
      const list = (this as any)['temporary' + type]
      list.push({
        name: file.name,
        url: response.data.fileUrl,
        fileSize: response.data.fileSize,
        fileUrl: response.data.fileUrl,
        uid: file.uid
      })
      this.$message.success('上传成功')
    },
    imageRemove(type: number, file: any, fileList: any) {
      const key = 'temporary' + type
      const removedUrl = file.url || (file.response && file.response.data && file.response.data.fileUrl)
      ;(this as any)[key] = (this as any)[key].filter((item: any) => item.uid !== file.uid && item.fileUrl !== removedUrl)
    },
    async fileSuccess(
      response: {
        code: number
        msg: string
        data: { fileSize: string; fileUrl: string }
      },
      file: any,
      fileList: any
    ) {
      var url = URL.createObjectURL(fileList[fileList.length - 1].raw)
      var audioElement = new Audio(url)
      var duration = parseInt(audioElement.duration + '')
      await audioElement.addEventListener('loadedmetadata', () => {
        console.log(parseInt(audioElement.duration + ''), '时长为秒，取整') // 时长为秒，取整
        const fileLength = parseInt(audioElement.duration + '')
        if (fileList.length > 3) {
          this.$message.error('最多上传三个视频')
          return
        }
        if (fileLength < 10 && fileLength > 100) {
          this.$message.error('视频不可小于10秒或大于100秒')
          this.isfileLengt = false
          return
        }
        if (file.size / 1024 / 1024 > 100) {
          this.$message.error('视频不可大于100M')
          this.isfileLengt = false
          return
        }
        if (response.code === 500) {
          this.$message.error(response.msg)
          return
        }
        if (file.raw.type !== 'video/mp4') {
          this.$message.error('请上传视频')
          return
        }
        console.log(file, 'file')
        this.videoList.push({
          name: file.raw.name,
          url: response.data.fileUrl,
          fileSize: response.data.fileSize,
          fileType: 'video',
          fileUrl: response.data.fileUrl,
          id: new Date().getTime()
        })
        this.$message.success('上传成功')
      })
    },
    fileEerror() {
      this.$message.error('文件上传失败')
    },
    // 删除文件
    fileRemove(file: any, uploadFiles: any) {
      console.log(file, uploadFiles, 'uploadFiles')
      this.videoList = this.videoList.filter((item: { id: number }) => item.id !== file.id)
    },
    // 选择出险人
    onSelectDangerous(event: any) {
      const obj = this.userList.filter((item: any) => item.id === event)[0]
      this.userId = obj.userId
      this.insurestartdate = obj.insureStartTime
      this.date = ''
    },

    filterRegionCode(code: string) {
      if (!code) return ''
      while (code.length < 6) {
        code += '0'
      }
      return code
    },
    // 第一步校验：基础资料
    validateStep1(): boolean {
      const reg = /^1[3-9]\d{9}$/
      if (!this.outDangerUserId) {
        this.$message.error('请选择出险人')
        return false
      }
      if (!this.date) {
        this.$message.error('请选择日期')
        return false
      }
      if (!this.outDangerPhone) {
        this.$message.error('请输入出险人手机号')
        return false
      }
      if (!reg.test(this.outDangerPhone)) {
        this.$message.error('请输入正确的出险人手机号码')
        return false
      }
      if (!this.phone) {
        this.$message.error('请输入报案人手机号')
        return false
      }
      if (!reg.test(this.phone)) {
        this.$message.error('请输入正确的报案人手机号码')
        return false
      }
      if (this.area.length === 0) {
        this.$message.error('请输入出险省市区')
        return false
      }
      if (!this.place) {
        this.$message.error('请输入出险地点')
        return false
      }
      if (!this.accidentType) {
        this.$message.error('请选择事故类型')
        return false
      }
      if (!this.hurtStatus) {
        this.$message.error('请选择是否有骨折')
        return false
      }
      if (!this.hospitalStatus) {
        this.$message.error('请选择是否住院')
        return false
      }
      if (!this.surgeryStatus) {
        this.$message.error('请选择是否手术')
        return false
      }
      return true
    },
    // 第二步校验：案件资料
    validateStep2(): boolean {
      if (!this.injuredArea) {
        this.$message.error('请输入受伤部位')
        return false
      }
      if (!this.treatmentMethod) {
        this.$message.error('请选择治疗方式')
        return false
      }
      if (!this.visitHospital) {
        this.$message.error('请填写就诊医院')
        return false
      }
      if (!this.accidentStatus) {
        this.$message.error('请选择出险状态')
        return false
      }
      if (!this.diagnosisResult) {
        this.$message.error('请输入诊断结果')
        return false
      }
      if (this.diagnosisResult.length > 500) {
        this.$message.error('诊断结果不可超过500字')
        return false
      }
      if (!this.accidentCause) {
        this.$message.error('请选择出险原因')
        return false
      }
      if (this.currentCost === '') {
        this.$message.error('请输入当前花费')
        return false
      }
      if (!/^\d+(\.\d{1,2})?$/.test(this.currentCost)) {
        this.$message.error('当前花费请输入正确的金额，最多两位小数')
        return false
      }
      if (!this.after) {
        this.$message.error('请输入详细事故经过')
        return false
      }
      return true
    },
    // 第三步校验：上传附件（设计图未标必填，仅留扩展位）
    validateStep3(): boolean {
      return true
    },
    onPrev() {
      if (this.activeStep > 0) {
        this.activeStep--
      }
    },
    async onNext() {
      if (this.activeStep === 0) {
        if (!this.validateStep1()) return
        this.saveDraft()
        this.activeStep = 1
        return
      }
      if (this.activeStep === 1) {
        if (!this.validateStep2()) return
        this.saveDraft()
        this.activeStep = 2
        return
      }
      if (!this.validateStep3()) return
      this.saveDraft()
      await this.onModifyCode()
    },
    // 提交
    async onModifyCode() {
      if (this.submitting) return
      const userInfo = this.userList.filter((item: { id: string }) => item.id === this.outDangerUserId)
      console.log(userInfo, 'userInfo')
      const province = codeToText[this.area[0]]
      const city = codeToText[this.area[1]]
      const district = codeToText[this.area[2]]

      let detailArea = [province, city, district].join('') + this.place
      this.submitting = true
      try {
        const result = await addReportCaseApi({
          accidentDetails: this.after,
          accidentType: this.accidentType,
          hurtStatus: this.hurtStatus,
          hospitalStatus: this.hospitalStatus,
          surgeryStatus: this.surgeryStatus,
          outDangerDate: this.date,
          outDangerPhone: this.outDangerPhone,
          outDangerPlace: detailArea,
          outDangerUserId: this.userId,
          outDangerUserName: userInfo[0].userName,
          visitHospital: this.visitHospital,
          province,
          city,
          district,
          detailAddress: this.place,
          provinceCode: this.filterRegionCode(this.area[0]),
          cityCode: this.filterRegionCode(this.area[1]),
          districtCode: this.filterRegionCode(this.area[2]),
          injuredArea: this.injuredArea,
          treatmentMethod: this.treatmentMethod,
          accidentStatus: this.accidentStatus,
          accidentCause: this.accidentCause,
          diagnosisResult: this.diagnosisResult,
          currentCost: this.currentCost,
          fileList: [1, 2, 3, 4, 5, 6, 7].map((n) => ({
            attachmentType: n,
            fileUrl: ((this as any)['temporary' + n] || []).map((item: any) => item.fileUrl)
          })),
          params: {
            photos: this.videoList
          },
          reportPhone: this.phone,
          recordId: this.outDangerUserId,
          insureType: this.$route.query.insureType
        })
        console.log(result, 'result')
      } catch (e) {
        this.submitting = false
        throw e
      }
      this.clearDraft()
      await this.$message.success('提交成功')
      store.commit('delPage', {
        page: '/long-insure-report-add',
        name: '报案理赔'
      })

      if (this.$route.query.insureType == 2) {
        await this.$router.push({
          path: '/long-insure-report'
        })
      }
      if (this.$route.query.insureType == 8) {
        await this.$router.push({
          path: '/insure-daily-claim'
        })
      }
    }
  }
})
